import React from 'react';
import cn from 'clsx';

import {
  ChevronDownRegularIcon,
  ChevronUpRegularIcon
} from '../../../../shared/icons/icons';

import styles from './select-toggle.scss';

interface SelectToggleProps {
  selectProps: {
    isDisabled: boolean;
    menuIsOpen: boolean;
  };
}

function SelectToggle(props: SelectToggleProps) {
  const {
    selectProps: { isDisabled, menuIsOpen: isOpen }
  } = props;

  const styleName = cn(
    styles['container'],
    isDisabled && styles['isDisabled'],
    'select-toggle'
  );

  return isOpen ? (
    <ChevronUpRegularIcon className={styleName} />
  ) : (
    <ChevronDownRegularIcon className={styleName} />
  );
}

export default SelectToggle;
